export default __webpack_public_path__ + "static/media/413.e93a1497.png";